import { fetchPostLoanDocumentsSigned } from '@iwoca/lapi-client/edge_de';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { useStateKey } from '../../../../../../../../../../iwQueryClient/useStateKey';
import { FUNDING_REQUIREMENTS_LIST_PATH } from '../../../../requirementStepPaths';

export function useCreditAgreement(documentId: string) {
    const stateKey = useStateKey();
    const history = useHistory();
    const { search } = useLocation();
    const queryClient = useQueryClient();

    const { mutate, isLoading, isError } = useMutation({
        mutationFn: () =>
            fetchPostLoanDocumentsSigned({
                stateKey,
                body: {
                    data: {
                        document_id: documentId,
                        date_signed: new Date().toISOString().split('T')[0]
                    }
                }
            }),
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['fetchGetFundingRequirements']
            });
            history.push(
                maintainStateKey({
                    pathname: FUNDING_REQUIREMENTS_LIST_PATH,
                    search
                })
            );
        }
    });

    return {
        downloadUrl: `/api/lending/edge/loan_documents/${stateKey}/unsigned/${documentId}/?file_format=pdf`,
        sign: () => mutate(),
        isSigning: isLoading,
        isSignError: isError
    };
}
